import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
declare global {
  interface Window {
    grecaptcha: any;
  }
}
@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {

   private scriptElement: HTMLScriptElement | null = null;

  constructor() { }

  loadScript(siteKey: string): Promise<void> {
    return new Promise((resolve, reject) => {
      // Always load fresh (do not cache state!)
      if (this.scriptElement) {
        this.scriptElement.remove();
        this.scriptElement = null;
      }

      const script = document.createElement('script');
      // 👇 Add cache buster param to force full reload
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}&cb=${Date.now()}`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.scriptElement = script;
        // Small delay to allow grecaptcha.enterprise to be ready
        setTimeout(() => {
          resolve();
        }, 100); // 100ms delay helps avoid race condition
      };

      script.onerror = (error) => reject(error);

      document.head.appendChild(script);
    });
  }

  cleanup() {
    // service Clean up

    // 1️⃣ Remove script
    if (this.scriptElement && this.scriptElement.parentNode) {
      this.scriptElement.parentNode.removeChild(this.scriptElement);
    }
    this.scriptElement = null;

    // 2️⃣ Remove badge
    const badge = document.querySelector('.grecaptcha-badge');
    if (badge && badge.parentNode) {
      badge.parentNode.removeChild(badge);
    }

    // 3️⃣ Delete global grecaptcha
    delete (window as any).grecaptcha;
  }

  executeRecaptcha(action: string): Promise<string> {
    const captcha = (window as any).grecaptcha?.enterprise || (window as any).grecaptcha;

    if (!captcha?.ready) {
      throw new Error('reCAPTCHA script not loaded yet');
    }

    return new Promise((resolve, reject) => {
      captcha.ready(() => {
        captcha.execute(environment.siteKey, { action })
          .then(resolve)
          .catch(reject);
      });
    });
  }
}
